import { useContext, useEffect, useState } from 'react';
import { MdCancel } from 'react-icons/md';
import { BsSearch } from 'react-icons/bs';
import GlobalGrid from '../../components/GlobalGrid';
import { ThemeContext } from '../../context/theme.context';
var current_query: string = '';
var searchText: string = '';
var resultLikeQuery = '';
const assetMeterReadingColumn = [
  { field: 'plantNo', Text: 'plant_no' },

  { field: 'monitorPoint', Text: 'monitor_point' },

  {
    field: 'readingDate',
    Text: 'reading_date',
    format: 'dd/MM/yyyy HH:mm:',
    type: 'date',
  },

  { field: 'measurePoint', Text: 'measure_point' },

  { field: 'monitorReading', Text: 'monitor_reading' },

  {
    field: 'auditDate',
    Text: 'audit_date',
    format: 'dd/MM/yyyy HH:mm',
    type: 'date',
  },

  {
    field: 'auditTime',
    Text: 'audit_time',
    format: 'dd/MM/yyyy HH:mm',
    type: 'date',
  },

  { field: 'pltMonitorRef', Text: 'plt_monitor_ref' },

  { field: 'readDiff', Text: 'read_diff' },

  {
    field: 'readingAlltime',
    Text: 'reading_alltime',
    format: 'dd/MM/yyyy HH:mm',
    type: 'date',
  },
];
var theQuerySearch = '';
const AseetMeterReading = () => {
  const [the_current_query, setThe_current_query] = useState('');
  const [signalOfLoad, setSignalOfLoad] = useState(false);
  const context = useContext(ThemeContext)
  var template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          border: '1px solid',
          borderBottomColor: 'rgb(173, 173, 193)',
          borderRightColor: 'transparent',
          borderTopColor: 'transparent',
          borderLeftColor: 'transparent',
          alignSelf: 'flex-end',
          height: 25,
          position: 'relative',
          right: 0,
          marginTop: '-12px',
        }}
      >
        <input
          style={{
            border: 'none',
            height: '20px',
            background: 'none',
          }}
          type={'text'}
          id='asset_meter'
          autoComplete='off'
          onKeyUp={inputEnterPress.bind(this)}
          onChange={(args: any) => {
            searchText = args.target.value;
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <MdCancel size={20} style={{}} onClick={removeSearch.bind(this)} />
        </div>
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch color={context.isDarkMode ? '#eaeaea' : '#292525'} size={20} style={{}} onClick={search.bind(this)} />
        </div>
      </div>
    );
  };
  const toolbarOptions: any = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    { template: template },
  ];
  const inputEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      search();
    }
  };
  const removeSearch = () => {
    if (searchText !== '') {
      $('#asset_meter').val('');
      if (resultLikeQuery !== '') {
        current_query = current_query.replace(resultLikeQuery, '');
        resultLikeQuery = '';
        buildQuery();
      }
    }
  };
  const search = () => {
    if (searchText !== '' || current_query !== '') {
      buildQuery();
    }
  };
  useEffect(() => {
    buildQuery();
  }, []);

  const buildQuery = () => {
    current_query = current_query.trimEnd();
    current_query = current_query.replace(theQuerySearch, '');
    theQuerySearch = '';
    if (searchText !== '' && searchText) {
      theQuerySearch = '$' + searchText;
      current_query = current_query + theQuerySearch;
    }
    setSignalOfLoad(true);
    setThe_current_query(current_query + ' ');
  };
  return (
    <div className='main-content-order-request'>
      <GlobalGrid
        columns={assetMeterReadingColumn}
        height={'calc(-290px + 100vh)'}
        query={the_current_query}
        toolbarOptions={toolbarOptions}
        get_query={'asset-meter-reading'}
        id={'asset-meter-reading-grid'}
        isFitInCOntent={false}
        signalOfLoad={signalOfLoad}
       
      />
    </div>
  );
};
export default AseetMeterReading;
